<template>
  <DoorList :quotation-id="quotationId" />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import DoorList from '@/domains/quotations/door-list/DoorList.vue'

definePage({
  props: true,
  name: 'door-list'
})

const route = useRoute('door-list')
const quotationId = route.params.id
</script>
